// eslint-disable-next-line no-shadow
export enum PortInStep {
    getCode, // 0 Initial step, no portIn has been started yet
    verifyCode, // 1 PortIn started but not fulfilled, waiting for the verification code
    successCode, // 2 PortIn is fulfilled
}

export const isSuccess = (step: PortInStep) => step === PortInStep.successCode;

export const isGettingCode = (step: PortInStep) => step === PortInStep.getCode;

export const isVerifying = (step: PortInStep) => step === PortInStep.verifyCode;
